module.exports = __webpack_public_path__ + "img/step_three.8599323d.png";